import QuantityRow from "./QuantityRow";

const DynamicActivitySection = ({
  activityConfig,
  form,
  setForm,
  errors,
  setErrors
}) => {

  // =====================================
  // MONITORING ACTIVITY
  // =====================================

  const isMonitoringActivity =
    Number(
      activityConfig?.requires_parameters
    ) === 1;

  // =====================================
  // MONITORING UI
  // =====================================

  if (isMonitoringActivity) {

    const sourceDetails =
      activityConfig?.source_field_details
        ? JSON.parse(
            activityConfig.source_field_details
          )
        : null;

    const parameterDetails =
      activityConfig?.parameter_details
        ? JSON.parse(
            activityConfig.parameter_details
          )
        : null;

    const sourceOptions =
      sourceDetails?.options || [];

    const mappedParameters =
      parameterDetails?.mapped_parameters || [];

    // ===================================
    // ADD ROW
    // ===================================

    const addRow = () => {

      const maxRows =
        sourceOptions.length || 1;

      if (
        form.entries.length >= maxRows
      ) {
        return;
      }

      setForm({
        ...form,

        entries: [

          ...form.entries,

          {
            source_id: "",
            source_name: "",
            value: "",
            parameters: []
          }
        ]
      });
    };

    // ===================================
    // REMOVE ROW
    // ===================================

    const removeRow = (index) => {

      const updated =
        form.entries.filter(
          (_, i) => i !== index
        );

      setForm({
        ...form,
        entries: updated
      });
    };

    return (

      <div className="le-card ecf-card">

        <div className="org-form-section-title">

          {activityConfig?.name} Details

        </div>

        {/* ROWS */}

        {form.entries.map(
          (entry, entryIndex) => {

            return (

              <div
                key={entryIndex}
                className="ecf-entry-card ecf-monitoring-row-card"
              >

                {/* TOP ROW */}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(6, minmax(0, 1fr))",
                    gap: 20,
                    alignItems: "end"
                  }}
                >

                  {/* SAMPLE POINT */}

                  <div className="org-form-field">

                    <label className="org-field-label">

                      {
                        sourceDetails?.field_label ||
                        "Sample Point"
                      }

                      {" "}

                      *

                    </label>

                    <select
                      className="org-field-input"
                      value={entry.source_id}
                      onChange={(e) => {

                        const updated =
                          [...form.entries];

                        const selected =
                          sourceOptions.find(
                            (item) =>
                              String(item.option_id) ===
                              String(e.target.value)
                          );

                        updated[
                          entryIndex
                        ].source_id =
                          e.target.value;

                        updated[
                          entryIndex
                        ].source_name =
                          selected?.option_value || "";

                        setForm({
                          ...form,
                          entries: updated
                        });
                      }}
                    >

                      <option value="">
                        Select Sample Point
                      </option>

                      {sourceOptions
  .filter((option) => {

    return !form.entries.some(
      (existingRow, existingIndex) => {

        return (
          existingIndex !== entryIndex &&
          String(existingRow.source_id) ===
          String(option.option_id)
        );
      }
    );
  })
  .map((option) => (

    <option
      key={option.option_id}
      value={option.option_id}
    >
      {option.option_value}
    </option>

  ))
}

                    </select>

                  </div>

                  {/* VALUE */}

                  <div className="org-form-field">

                    <label className="org-field-label">

                      Value *

                    </label>

                    <input
                      type="number"
                      className="org-field-input"
                      placeholder="e.g. 500"
                      value={entry.value || ""}
                      onChange={(e) => {

                        const updated =
                          [...form.entries];

                        updated[
                          entryIndex
                        ].value =
                          e.target.value;

                        setForm({
                          ...form,
                          entries: updated
                        });
                      }}
                    />

                  </div>

                  {/* UNIT */}

                  <div className="org-form-field">

                    <label className="org-field-label">

                      Unit

                    </label>

                    <input
                      type="text"
                      className="org-field-input"
                      value={
                        activityConfig?.unit_name || ""
                      }
                      disabled
                    />

                  </div>

                  {/* EMPTY SPACERS */}

                  <div />
                  <div />

                  {/* REMOVE */}

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      height: "100%"
                    }}
                  >

                    {form.entries.length > 1 && (

                      <button
                        type="button"
                        className="ecf-remove-btn"
                        onClick={() =>
                          removeRow(entryIndex)
                        }
                      >
                        ✕
                      </button>

                    )}

                  </div>

                </div>

                {/* PARAMETERS */}

                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      "repeat(6, minmax(0, 1fr))",
                    gap: 20,
                    marginTop: 24
                  }}
                >

                  {mappedParameters.map(
                    (param) => {

                      const existing =
                        entry.parameters?.find(
                          (p) =>
                            String(p.parameter_id) ===
                            String(param.parameter_id)
                        );

                      return (

                        <div
                          key={param.parameter_id}
                          className="org-form-field"
                        >

                          <label className="org-field-label">

                            {param.code}

                            {" "}

                            ({param.unit_name})

                          </label>

                          <input
  type="number"
  className={`org-field-input ${
    existing?.is_out_of_range
      ? "ecf-input-warning"
      : ""
  }`}
  placeholder="Enter Value"
  value={
    existing?.value || ""
  }
  onChange={(e) => {

    const updated =
      [...form.entries];

    if (
      !updated[
        entryIndex
      ].parameters
    ) {

      updated[
        entryIndex
      ].parameters = [];
    }

    const parameterIndex =
      updated[
        entryIndex
      ].parameters.findIndex(
        (p) =>
          String(
            p.parameter_id
          ) ===
          String(
            param.parameter_id
          )
      );

    const parameterPayload = {

      parameter_id:
        param.parameter_id,

      parameter_name:
        param.name,

      parameter_code:
        param.code,

      unit:
        param.unit_name,

      min_limit:
        param.min_limit,

      max_limit:
        param.max_limit,

      value:
        e.target.value,

      is_out_of_range: false
    };

    if (
      parameterIndex >= 0
    ) {

      updated[
        entryIndex
      ].parameters[
        parameterIndex
      ] = parameterPayload;

    } else {

      updated[
        entryIndex
      ].parameters.push(
        parameterPayload
      );
    }

    setForm({
      ...form,
      entries: updated
    });
  }}

  // =====================================
  // VALIDATE ON BLUR
  // =====================================

  onBlur={(e) => {

    const enteredValue =
      Number(e.target.value);

    const min =
      param.min_limit;

    const max =
      param.max_limit;

    const isBelowMin =
      min !== null &&
      min !== undefined &&
      enteredValue < Number(min);

    const isAboveMax =
      max !== null &&
      max !== undefined &&
      enteredValue > Number(max);

    const isOutOfRange =
      isBelowMin ||
      isAboveMax;

    const updated =
      [...form.entries];

    const parameterIndex =
      updated[
        entryIndex
      ].parameters.findIndex(
        (p) =>
          String(
            p.parameter_id
          ) ===
          String(
            param.parameter_id
          )
      );

    if (
      parameterIndex >= 0
    ) {

      updated[
        entryIndex
      ].parameters[
        parameterIndex
      ].is_out_of_range =
        isOutOfRange;
    }

    setForm({
      ...form,
      entries: updated
    });
  }}
/>
{
  existing?.is_out_of_range && (

    <div className="ecf-warning-text">

      ⚠ Outside acceptable range

    </div>

  )
}

                          <div className="ecf-parameter-range">

                            Acceptable Range:

                            {" "}

                            {param.min_limit || 0}

                            {" - "}

                            {param.max_limit || "∞"}

                          </div>

                        </div>

                      );
                    }
                  )}

                </div>

              </div>

            );
          }
        )}

        {/* ADD MORE */}

        {sourceOptions.length > 1 &&
          form.entries.length <
            sourceOptions.length && (

          <div className="ecf-add-more-global">

            <button
              type="button"
              className="ecf-add-btn"
              onClick={addRow}
            >
              + Add More
            </button>

          </div>

        )}

      </div>

    );
  }

  // =====================================
  // QUANTITY ACTIVITIES
  // =====================================

  if (
    activityConfig.data_type ===
    "quantity"
  ) {

    const sourceDetails =
      activityConfig.source_field_details
        ? JSON.parse(
            activityConfig.source_field_details
          )
        : null;

    const disposalDetails =
      activityConfig.disposal_field_details
        ? JSON.parse(
            activityConfig.disposal_field_details
          )
        : null;

    const activeOptions =
      sourceDetails?.options ||
      disposalDetails?.options ||
      [];

    const addRow = () => {

      const maxRows =
        activeOptions.length || 1;

      if (
        form.entries.length >= maxRows
      ) {
        return;
      }

      setForm({
        ...form,
        entries: [
          ...form.entries,
          {
            source_id: "",
            source_name: "",
            value: ""
          }
        ]
      });
    };

    return (

      <div className="le-card ecf-card">

        <div className="org-form-section-title">

          {activityConfig.name} Details

        </div>

        {form.entries.map(
          (row, index) => (

            <QuantityRow
              key={index}
              index={index}
              row={row}
              form={form}
              setForm={setForm}
              activityConfig={activityConfig}
              errors={errors}
              setErrors={setErrors}
            />

          )
        )}

        {activeOptions.length > 1 &&
          form.entries.length <
            activeOptions.length && (

          <div className="ecf-add-more-global">

            <button
              type="button"
              className="ecf-add-btn"
              onClick={addRow}
            >
              + Add More
            </button>

          </div>

        )}

      </div>

    );
  }

  return null;
};

export default DynamicActivitySection;